export default "__VITE_ASSET__c916c5ee__"